
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.about-me-heading {

    margin-bottom: 1rem
}

@media (min-width: 768px) {

    .about-me-heading {

        margin-bottom: 1.5rem
    }
}

.about-me-text {

    margin-bottom: 1.5rem;

    font-family: var(--ff-body);

    font-size: var(--fs-lg);

    line-height: var(--lh-lg)
}

@media (min-width: 768px) {

    .about-me-text {

        margin-bottom: 2.5rem
    }
}
`;